// Labels of the Berichtsheft pages.

export const placeLabels = t => ({
  BETRIEB: t("Company"),
  SCHULE: t("Vocational school"),
  UEBERBETRIEBLICH: t("Inter-company training"),
  URLAUB: t("Holiday"),
  KRANK: t("Sick"),
  FEIERTAG: t("Public holiday"),
  FREI: t("Day off")
});

export const reportStatusLabels = t => ({
  draft: t("Draft"),
  submitted: t("Handed in"),
  returned: t("Returned"),
  signed: t("Signed"),
  missing: t("Missing")
});

export const REPORT_STATUS_COLORS = {
  draft: "default",
  submitted: "processing",
  returned: "warning",
  signed: "success",
  missing: "error"
};

export const weekdayLabels = t => [
  t("Monday"),
  t("Tuesday"),
  t("Wednesday"),
  t("Thursday"),
  t("Friday"),
  t("Saturday"),
  t("Sunday")
];
